import Layout from "../../containers/Layout";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const TermsOfService = () => {
  return (
    <Layout mt={16}>
      <Seo
        title="Terms of Service"
        description="Terms and conditions for booking lessons and joining programs with Spanish with Alex."
        path="/terms-of-service"
      />
      <BoxInfoTemplate
        title=""
        subTitle="Terms of Service"
        mainText="Please read carefully before booking or joining any program."
        iconType="alert"
        showQuotes={false}
        showShadow={true}
        borderColor="gray"
      />

      <div
        className="terms-container"
        style={{ textAlign: "left", padding: "1rem 0" }}
      >
        <h2 style={{ marginBottom: "1rem" }}>1. General Information</h2>
        <p style={{ marginBottom: "1rem" }}>
          Spanish with Alex is an independent educational platform offering
          online lessons, downloadable materials, and immersion programs in
          Spain. By using our services, you agree to the terms described here.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>2. Booking and Cancellations</h2>
        <ul style={{ marginBottom: "1rem" }}>
          <li>You may reschedule lessons up to 24 hours in advance.</li>
          <li>
            Cancellations within 24 hours are not refundable or exchangeable.
          </li>
          <li>
            Lesson packages are valid for 6 months from the purchase date.
          </li>
          <li>You have 15 days to request a refund for unused packages.</li>
        </ul>

        <h2 style={{ marginBottom: "1rem" }}>3. Student Conduct</h2>
        <p style={{ marginBottom: "1rem" }}>
          We expect respectful and professional behavior. We reserve the right
          to suspend access to lessons or programs in cases of inappropriate
          conduct.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>4. Data and Privacy</h2>
        <p style={{ marginBottom: "1rem" }}>
          Your personal data (such as name and email) is used solely for
          communication and program logistics. We never sell or share your
          information with third parties.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>5. Changes to Terms</h2>
        <p style={{ marginBottom: "1rem" }}>
          Terms of service may be updated. Significant changes will be
          communicated in advance via email or on our website.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>6. Eligibility and Ownership</h2>
        <ul style={{ marginBottom: "1rem" }}>
          <li>
            Access to the services is personal and non-transferable, valid for a
            single user only.
          </li>
          <li>
            You must be at least 18 years old, or of legal age in your province,
            territory, or country.
          </li>
          <li>
            Minors under 18 (or under the legal age applicable in their region)
            may use the service under the supervision of a parent or legal
            guardian, through the account of such responsible adult. These Terms
            of Service apply to the supervising adult.
          </li>
        </ul>

        <p style={{ marginTop: "2rem" }}>
          <strong>Legal Representative of SPANISH WITH ALEX</strong>
          <br />
          Holder: Spanish with Alex
          <br />
          Email: <span>Join the school newsletter and get the email.</span>
        </p>
      </div>
    </Layout>
  );
};

export default TermsOfService;
